import { useEffect, useCallback } from 'react';
import { useSettingsStore } from '../stores/settingsStore';

/**
 * Hook for managing media devices.
 */
export function useMediaDevices() {
  const {
    availableMicrophones,
    availableCameras,
    availableSpeakers,
    microphoneDeviceId,
    cameraDeviceId,
    speakerDeviceId,
    loadDevices,
    setMicrophoneDevice,
    setCameraDevice,
    setSpeakerDevice,
  } = useSettingsStore();

  useEffect(() => {
    loadDevices();

    const handleDeviceChange = () => {
      loadDevices();
    };

    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
    };
  }, [loadDevices]);

  const selectMicrophone = useCallback(
    (deviceId: string) => {
      setMicrophoneDevice(deviceId);
    },
    [setMicrophoneDevice]
  );

  const selectCamera = useCallback(
    (deviceId: string) => {
      setCameraDevice(deviceId);
    },
    [setCameraDevice]
  );

  const selectSpeaker = useCallback(
    (deviceId: string) => {
      setSpeakerDevice(deviceId);
    },
    [setSpeakerDevice]
  );

  return {
    microphones: availableMicrophones,
    cameras: availableCameras,
    speakers: availableSpeakers,
    selectedMicrophone: microphoneDeviceId,
    selectedCamera: cameraDeviceId,
    selectedSpeaker: speakerDeviceId,
    selectMicrophone,
    selectCamera,
    selectSpeaker,
    refresh: loadDevices,
  };
}
